"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noticeSelector = void 0;
const noticeSelector = _ref => {
  let {
    view
  } = _ref;
  return view.data && view.data.notice;
};
exports.noticeSelector = noticeSelector;